import axios from "axios";

export const saveToDatabase = (payload, destination_url) => {
  return axios
    .post(destination_url, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteDatabase = (payload, destination_url) => {
  return axios
    .post(destination_url, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const generateReport = (payload, destination_url) => {
  return axios
    .post(destination_url, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

